export enum StatuesReq {
    GameChoice = 0,
    PlayerChoice = 1,
    Random = 2,
}
